import useReplayPendingLikes from "@/hooks/useReplayPendingLikes";

/** Mount inside Auth0Provider to replay guest like intents after sign-in. */
export default function PendingLikeReplay(): null {
    useReplayPendingLikes();
    return null;
}
